import { render } from "./maskComp.vue?vue&type=template&id=af03fde6"
import script from "./maskComp.vue?vue&type=script&lang=js"
export * from "./maskComp.vue?vue&type=script&lang=js"

import "./maskComp.vue?vue&type=style&index=0&id=af03fde6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__